import React from "react"
import { graphql, useStaticQuery } from "gatsby"

import { Element } from "legacy/components/shared/base"
import LinkList from "./LinkList"
import { PrismicFooterDataBodyNavColumn } from "types/__generated__/gatsby-graphql"

const FooterNav: React.FC = (): React.ReactElement => {
  const response = useStaticQuery(graphql`
    query Footer {
      allPrismicFooter {
        edges {
          node {
            data {
              body {
                ... on PrismicFooterDataBodyNavColumn {
                  id
                  items {
                    link_text
                    link_url {
                      document {
                        ... on PrismicBlogPost {
                          id
                          uid
                          url
                        }
                        ... on PrismicLegalPage {
                          id
                          uid
                          url
                        }
                        ... on PrismicHomepage {
                          id
                          url
                        }
                        ... on PrismicOurMissionPage {
                          id
                          uid
                          url
                        }
                        ... on PrismicPage {
                          id
                          uid
                          url
                        }
                      }
                      id
                      link_type
                      type
                      uid
                      url
                    }
                  }
                  primary {
                    headline {
                      text
                    }
                  }
                  slice_type
                }
              }
            }
          }
        }
      }
    }
  `)

  const linkLists = response.allPrismicFooter.edges[0].node.data.body

  return (
    <Element
      display="flex"
      flexDirection={["column", "row"]}
      gridArea="nav"
      my={["0", "40", "40", "0"]}
    >
      {linkLists.map((list: PrismicFooterDataBodyNavColumn, index: number) => {
        return <LinkList key={`nav_${index}`} list={list} />
      })}
    </Element>
  )
}

export default FooterNav
